import React, { Fragment, useState } from "react";
import ReCaptcha from "react-google-recaptcha";

const ReCaptchaComponents = ({ style, onChange }) => {

    const [siteKey] = useState("6LeohPoSAAAAAEP1-VlqPbwMZ2p8V2SYRo7pmdfN");

    const handleChangeReCaptcha = (e) => {
        onChange(e)
    }

    return (
        <Fragment>
            <ReCaptcha
                style={style}
                sitekey={siteKey}
                size="normal"
                onChange={handleChangeReCaptcha}
            />
        </Fragment>
    )
}

export default ReCaptchaComponents;